import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import APIS from "./utils/APIS"
import { isLoggedIn, setUser } from "./utils/auth"


const checkLoggedRefresh = () => {
  //console.log("checkLoggedRefresh")
  APIS.getLoginStatus().then(result => {
    if (result?.message == "status" && result?.user) {
      let actUser = isLoggedIn()
      if (actUser === false) {
        //on doit donc logger le user et reload
        setUser(result?.user)
        document.location.reload()
      } else {
        if (actUser !== result?.user?.id) { //problème, on logout et reload
          setUser({})
          document.location.reload()
        }
      }
    } else if (result?.reseauIndisponible === true) {
      // 02/09/2026 : serveur muet, on ne touche pas a la session locale.
      console.log("statut de session indisponible, on garde la session en place")
    } else {
      if (isLoggedIn()) {
        setUser({})
        document.location.reload()
      }
    }
  })
}
checkLoggedRefresh()


/* ⛔ R18-b — 23/09/2026. `createRoot` remplace l'ancien point de montage : React 18
   cesse de tourner en mode de compatibilite React 17, et le regroupement
   automatique des mises a jour s'active. Surface mesuree dans THE SCAN : 9
   fichiers, presque tous des formulaires (connexion, inscription, mot de passe).
   Retour arriere : le tag git `avant-r18b`. */
createRoot(document.getElementById('root')).render(
  (
    <BrowserRouter>
        <App />
    </BrowserRouter>
  )
);
